import DOMPurify from 'dompurify';

export default {
  mounted(el, binding) {
    // Store the raw input value in a separate property
    el._rawValue = el.value;

    // Intercept the input event
    el.addEventListener('input', (event) => {
      const rawValue = event.target.value; // Get the raw input value
      el._rawValue = rawValue; // Store the raw value for display

      // Sanitize the value
      const sanitizedValue = DOMPurify.sanitize(rawValue);

      // Update the bound variable using the provided expression
      binding.instance[binding.expression] = sanitizedValue;

      // Update the input field with the raw value (user sees unsanitized input)
      el.value = rawValue;
    });

    // Sanitize the initial value and store it in the variable
    const initialValue = el.value;
    const sanitizedInitialValue = DOMPurify.sanitize(initialValue);
    binding.instance[binding.expression] = sanitizedInitialValue;
  },

  // Update the input field when the bound variable changes
  updated(el, binding) {
    if (el._rawValue !== binding.value) {
      el.value = binding.value; // Sync the input field with the bound variable
      el._rawValue = binding.value; // Update the raw value
    }
  },
};
